// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const LightningFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 52 84" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.963 83.5a4.496 4.496 0 0 1-2.194-.586l-.002-.001a4.476 4.476 0 0 1-2.04-5.205l8.56-26.537-14.369-4.632a4.45 4.45 0 0 1-1.981-7.167L34.68 2.02A4.445 4.445 0 0 1 39.372.709a4.452 4.452 0 0 1 2.888 5.583l-8.56 26.53 14.386 4.632A4.422 4.422 0 0 1 51 40.513a4.354 4.354 0 0 1-.966 4.124L17.308 81.972a4.407 4.407 0 0 1-3.345 1.528Z"
			fill="#fff"
		/>
	</svg>
);
export default LightningFilled;
